export enum SizeUnit {
  percent = 'percent' as any,
  pixel = 'pixel' as any,
}
